import { Fragment, h, JSX } from 'preact';

import type { MockLine } from '../../types/print';
import { ButtonOrLink, ButtonOrLinkProps } from './ButtonOrLink';
import { Loader } from './Loader';

export interface PrintProps {
    buttons?: ButtonOrLinkProps[];
    isLoading?: boolean;
    result?: PrintResultProps;
}

interface PrintResultProps {
    mainMessage: string;
    secondaryMessage?: string;
    recommendation?: string;
    rawTitle?: string;
    raw?: string;
    hexStatus?: string;
    mockData?: MockLine[];
}

const PrintResult = (props: PrintResultProps): JSX.Element => (
    <Fragment>
        <p class='print__main-message'>{props.mainMessage}</p>
        {props.secondaryMessage && <p>{props.secondaryMessage}</p>}
        {props.recommendation && <p>{props.recommendation}</p>}
        {props.raw && (
            <Fragment>
                <p>{props.rawTitle}:</p>
                <p class='print__raw-response'>{props.raw}</p>
            </Fragment>
        )}
        {props.hexStatus && <p>Hex status: {props.hexStatus}</p>}
        {props.mockData && <MockData lines={props.mockData} />}
    </Fragment>
);

const MockData = (props: { lines: MockLine[] }): JSX.Element => (
    <div>
        <div>Mocked printer commands:</div>
        {props.lines.map((line) => {
            switch (line.type) {
                case 'text':
                    return <div>{line.line}</div>;
                case 'qr':
                    return (
                        <div class="print__mock-qr-box">
                            <div class="print__mock-meta">QR</div>
                            <div class="print__mock-qr-code">{line.content}</div>
                            <div class="print__mock-meta">
                                <div>size: {line.size}</div>
                                <div>{JSON.stringify(line.settings)}</div>
                            </div>
                        </div>
                    );
                case 'meta':
                    return <div class="print__mock-meta">{line.line}</div>;
                case 'empty':
                    return (
                        <div class="print__mock-meta">
                            empty line
                            {line.dots && ' with dots'}
                            {line.count > 1 && ` x${line.count}`}
                        </div>
                    );
                case 'pageBreak':
                    return <div class="print__mock-page-break" />;
            }
        })}
    </div>
);

export const Print = (props: PrintProps): JSX.Element => (
    <Fragment>
        {props.buttons && (
            <div class='print__buttons'>
                {props.buttons.map((button) => <div><ButtonOrLink {...button} /></div>)}
            </div>
        )}
        <Loader isHidden={!props.isLoading} />
        {props.result && <PrintResult {...props.result} />}
    </Fragment>
);
